import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { LegalPage } from '@/types'

import { getLegalPage } from '@/lib/cms'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { LegalView } from '@/components/landing/legal/legal-view'

interface PrivacyProps {
    page: LegalPage | null
}

const Privacy: FC<PrivacyProps> = ({ page }): ReactNode => {
    return (
        <Layout tone='paper' footerCta={false}>
            <Seo title='Privacy policy' description='How nSure.ai collects, uses and protects personal data.' />
            <LegalView page={page} fallbackTitle='Privacy Policy' current='/privacy-policy' />
        </Layout>
    )
}

export const getStaticProps: GetStaticProps<PrivacyProps> = async () => {
    try {
        const page = await getLegalPage('privacy-policy')

        return { props: { page }, revalidate: 300 }
    }
    catch (error) {
        console.error('Privacy policy could not be loaded:', error instanceof Error ? error.message : error)

        return { props: { page: null }, revalidate: 30 }
    }
}

export default Privacy
